"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var PersonIcon = function PersonIcon(_ref) {
  var rest = (0, _extends2.default)({}, _ref);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/_react.default.createElement("switch", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#231F20'
    },
    d: "M3.5,20.9h17V17c0-2.6-5.6-4.1-8.5-4.1S3.5,14.3,3.5,17V20.9z M5,17.1c0-1,3.8-2.6,7-2.6s7,1.6,7,2.6v2.4H5 V17.1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#231F20'
    },
    d: "M12,3.1c-2.3,0-4.1,1.8-4.1,4.1s1.8,4.1,4.1,4.1s4.1-1.8,4.1-4.1S14.3,3.1,12,3.1z M12,9.8 c-1.5,0-2.6-1.2-2.6-2.6c0-1.5,1.2-2.6,2.6-2.6s2.6,1.2,2.6,2.6C14.7,8.6,13.5,9.8,12,9.8z"
  })))));
};

var _default = PersonIcon;
exports.default = _default;